import React, { useState, useEffect } from "react";
import { AppBar, Toolbar, IconButton, Switch, Box } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import { styled } from "@mui/system";
import DesktopMenu from "./DesktopMenu";
import MobileDrawer from "./MobileDrawer";
import LogoComponent from "./LogoComponent";

const NavbarContainer = styled(AppBar)(({ theme }) => ({
  [theme.breakpoints.down("sm")]: {
    padding: theme.spacing(1),
  },
}));

const Navbar = ({ themeMode, toggleTheme }) => {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [checked, setChecked] = useState(themeMode === "dark");

  useEffect(() => {
    setChecked(themeMode === "dark");
  }, [themeMode]); // Se sincroniza cuando el tema cambia

  const menuItems = [
    { text: "Home", path: "/" },
    { text: "About Me", path: "/about" },
    { text: "Skills", path: "/skills" },
    { text: "Portfolio", path: "/portfolio" },
    { text: "Contact", path: "/contact" },
  ];

  const toggleDrawer = (isOpen) => () => {
    setDrawerOpen(isOpen);
  };

  return (
    <NavbarContainer position="static" sx={{ overflowX: "hidden" }}>
      <Toolbar>
        <IconButton
          edge="start"
          color="inherit"
          aria-label="menu"
          onClick={toggleDrawer(true)}
          sx={{ display: { sm: "none" }, marginRight: 2 }}
        >
          <MenuIcon />
        </IconButton>
        <LogoComponent />
        <Box sx={{ flexGrow: 1, display: { xs: "none", sm: "flex" } }}>
          <DesktopMenu menuItems={menuItems} themeMode={themeMode} toggleTheme={toggleTheme} />
        </Box>
        <Switch
          checked={checked}
          onChange={() => {
            setChecked((prev) => !prev);
            toggleTheme();
          }}
          color="default"
          sx={{ display: { xs: "none", sm: "block" }, marginLeft: "auto" }}
        />
        <MobileDrawer menuItems={menuItems} drawerOpen={drawerOpen} toggleDrawer={toggleDrawer} />
      </Toolbar>
    </NavbarContainer>
  );
};

export default Navbar;
